import { Stack, TextField } from "@mui/material";
import clsx from "clsx";

function FormikTextField({
  name,
  label,
  type = "text",
  disabled = false,
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  className,
  inputErrorClassName,
  inputNoErrorClassName,
  errorClassName,
  errorComponent = "span",
  stackProps,
  ...textFieldProps
}) {
  const hasError = Boolean(errors?.[name] && touched?.[name]);
  const errorMessage = hasError ? errors?.[name] : null;
  const ErrorTag = errorComponent;

  return (
    <Stack {...stackProps}>
      <TextField
        label={label}
        name={name}
        type={type}
        disabled={disabled}
        className={clsx(
          className,
          hasError ? inputErrorClassName : inputNoErrorClassName
        )}
        onChange={textFieldProps.onChange || handleChange}
        onBlur={textFieldProps.onBlur || handleBlur}
        value={
          textFieldProps.value !== undefined
            ? textFieldProps.value
            : values?.[name] ?? ""
        }
        {...textFieldProps}
      />
      {errorMessage ? (
        <ErrorTag className={errorClassName}>{errorMessage}</ErrorTag>
      ) : null}
    </Stack>
  );
}

export default FormikTextField;
